<template>
    <b-card
        no-body
    >
        <div
            class="card-body text-center"
        >
            <p>
                사용가능한 기간이 {{ availablePeriod }} 일 남았습니다. 연장하시려면 다음 버튼을 클릭하세요.
            </p>
            <div
            >
                <b-button
                    variant="warning"
                    @click="extendPeriod"
                >
                    <feather-icon
                        class="mr-25"
                        icon="CheckSquareIcon"
                    />
                    <span class="align-middle">
                        Extension
                    </span>
                </b-button>
            </div>
        </div>
    </b-card>
</template>

<script>
import { getCurrentInstance } from '@vue/composition-api'
import bus from '@/libs/bus'
export default {
    props: {
        availablePeriod: {
            type: Number
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const updatePeriodExtension = () => store.dispatch('$_open_api/updatePeriodExtension')
        const extendPeriod = () => {
            updatePeriodExtension().then(() => {
                const message = vm.$t('org.message.The usable period has been extended')
                bus.$emit('request:success', { title: 'SUCCESS', content: message })
                vm.$emit('alert:message', { status: 'success', message })
            }).catch(error => {
                if (error?.response?.data?.errorMessage) {
                    vm.$emit('alert:message', { status: 'danger', message: error.response.data.errorMessage })
                }
            })
        }
        return {
            extendPeriod
        }
    }
}
</script>

<style>

</style>
